

































































































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import Card from '@/components/Card.vue'
import Icon from '@/components/Icon.vue'
import { getModule } from 'vuex-module-decorators'
import { ChainModule } from '@/store/modules/chain.module'
import { IAdminTask, EAdminTaskStatus, EUserStatus, IOnboardingMilestoneTemplate, IUser, IAdminTaskHistory, EAdminTaskAction, IOnboardingMilestone, EOnboardingMilestoneStatus, IOnboarding, ITrainingMilestone, ITrainingMilestoneTemplate } from '@zunta/configurations'
import NewTaskModal from './NewTaskModal.vue'
import RescheduleTaskModal from './RescheduleTaskModal.vue'
import CompleteTaskModal from './CompleteTaskModal.vue'
import { UserModule } from '@/store/modules/user.module'
import ScrollView from '@/components/ScrollView.vue'
import Mentions from '@/components/Mentions.vue'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import { getFilePathByKey } from '@/utils/helpers'
import Avatar from '@/components/Avatar.vue'
import { IMiniTabsItem } from '@/interfaces/Tabs'
import MiniTabs from '@/components/MiniTabs.vue'
import Switcher from '@/components/Switcher.vue'
import { Milestone, MilestoneTemplate } from '@/store/types/milestone'
const moment = require('moment')
const sortBy = require('lodash.sortby')
@Component({
  props: {
    type: {
      type: String,
      default: 'chain'
    },
    task: {
      type: Object,
      default: null
    },
    fullView: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Card,
    Icon,
    Mentions,
    MiniTabs,
    Switcher,
    Avatar,
    NewTaskModal,
    RescheduleTaskModal,
    CompleteTaskModal,
    DateTimeLabel,
    ScrollView
  }
})
export default class TaskDetails extends Vue {
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store);
  userModuleInstance: UserModule = getModule(UserModule, this.$store);
  EAdminTaskAction: any = EAdminTaskAction;
  activeTab: string = 'overview';
  textMessage: string = '';
  EUserStatus: any = EUserStatus;
  isWantAddTask: boolean = false;
  isWantRescheduleTask: boolean = false
  isWantCompleteTask: boolean = false
  isWantEditTask: boolean = false
  taskIndex: number = 0;
  isWantShowCompleted: boolean = false;

  getFilePathByKey: Function = getFilePathByKey;

  tabItems: IMiniTabsItem[] = [{
    key: 'overview',
    content: 'Overview',
    value: 'overview'
  }, {
    key: 'responses',
    value: 'responses',
    content: () => {
      return `Responses (${this.taskHistoriesComments.length})`
    }
  }, {
    key: 'action-log',
    content: 'Action Log',
    value: 'actionLogs'
  }]

  get adminTasks () {
    return this.$store.state.chain.adminTasks
  }

  get tasks () {
    return sortBy(this.adminTasks.filter((task: IAdminTask) => {
      if (this.isWantShowCompleted) {
        return true
      }
      return task.status === EAdminTaskStatus.TODO
    }), (task: IAdminTask) => {
      return task.status === EAdminTaskStatus.TODO ? 0 : 1
    })
  }
  get user () {
    return this.$store.state.user.selectedUser
  }

  get chain () {
    return this.$store.state.chain.chain
  }

  get taskHistories () {
    return this.$store.state.chain.adminTaskHistories || []
  }

  get taskHistoriesComments () {
    return this.taskHistories.filter((history: IAdminTaskHistory) => {
      return history.action === EAdminTaskAction.COMMENT
    })
  }

  get milestoneTemplates () {
    if (this.$props.type === 'user') {
      return this.$store.state.chain.trainingTemplates
    }
    return this.$store.state.chain.onboardingTemplates
  }

  get taskTemplate () {
    if (this.$props.type === 'user') {
      return this.currentTask.trainingMilestone ? this.currentTask.trainingMilestone.template : null
    }
    return this.currentTask.onboardingMilestone ? this.currentTask.onboardingMilestone.template : null
  }

  get currentTask () {
    return this.$props.task || this.tasks[this.taskIndex]
  }

  get onboardingData () {
    return this.$store.state.chain.onboardingData
  }

  get trainingMilestones () {
    return this.$store.state.user.trainingMilestones
  }

  get activeTask () {
    return this.$route.query.activeTask
  }

  get usersOptions () {
    return this.$store.state.user.users
        .map((item: IUser) => {
          return {
            label: `${item.firstName ? item.firstName : ''} ${item.lastName ? item.lastName : ''}`,
            key: `${item.firstName ? item.firstName : ''} ${item.lastName ? item.lastName : ''}`,
            replaceValue: item.id,
            value: `${item.firstName ? item.firstName : ''}${item.lastName ? item.lastName : ''}`.split(' ').join('')
          }
        })
  }

  async toggleShowComplete () {
    this.taskIndex = 0
    await this.fetchHistory()
    if (this.activeTask) {
      this.$router.replace({ query: { ...this.$route.query, activeTask: '' } })
    }
  }

  async mounted () {
    this.$watch('activeTask', () => {
      this.openActiveTask()
    })
    if (this.activeTask) {
      this.openActiveTask()
    } else {
      await this.fetchHistory()
    }
  }

  changeTab (newTab: string) {
    this.activeTab = newTab
    this.textMessage = ''
    if (this.activeTab === 'responses') {
      this.$nextTick(() => {
        this.scrollDown()
      })
    }
  }
  isTaskCompleted (taskId: number) {
    return !!this.adminTasks.find((task: IAdminTask) => {
      return task.id === taskId && task.status === EAdminTaskStatus.COMPLETE
    })
  }
  openActiveTask () {
    if (this.activeTask) {
      if (this.isTaskCompleted(+this.activeTask)) {
        this.isWantShowCompleted = true
      }
      const index = this.tasks.findIndex((task: IAdminTask) => {
        return task.id === parseInt(this.activeTask as string)
      })
      if (index !== -1) {
        this.taskIndex = index
        this.$nextTick(() => {
          this.fetchHistory()
        })
      }
    }
  }

  handleTextMessageChange (event: any, checkInputSymbol?: Function) {
    this.textMessage = event.target.innerHTML
    if (checkInputSymbol) {
      checkInputSymbol(event)
    }
  }

  setTextMessage () {
    // @ts-ignore
    this.textMessage = this.$refs.textMessageBox.innerHTML
    // @ts-ignore
    this.$refs.textMessageBox.focus()
  }
  getTasksForMilestone (milestone: Milestone) {
    if (this.$props.type === 'user') {
      return this.tasks.filter((task: IAdminTask) => {
        return task.trainingMilestone && ((task.trainingMilestone as Milestone).template as MilestoneTemplate).id === (milestone.template as MilestoneTemplate).id
      })
    }
    return this.tasks.filter((task: IAdminTask) => {
      return task.onboardingMilestone && ((task.onboardingMilestone as Milestone).template as MilestoneTemplate).id === (milestone.template as MilestoneTemplate).id
    })
  }

  isActiveTask (task: IAdminTask) {
    return task.status === EAdminTaskStatus.TODO
  }

  checkMilestones (milestones: Milestone[]) {
    const task = this.currentTask
    if (!task.trainingMilestone && !task.trainingMilestone) {
      return true
    }
    const taskMilestone = milestones.find((milestone: Milestone) => {
      if (this.$props.type === 'user') {
        return task.trainingMilestone.template.id === (milestone.template as MilestoneTemplate).id
      }
      return task.onboardingMilestone.template.id === (milestone.template as MilestoneTemplate).id
    })
    if (!taskMilestone) {
      throw new Error('somethign went wrong')
    }
    const sortedMilestones = sortBy(milestones, (milestone: Milestone) => {
      const template = milestone.template as MilestoneTemplate
      let order = template.order
      if (template.parent) {
        const parentMilestone = milestones.find((iMilestone: Milestone) => (
          (iMilestone.template as MilestoneTemplate).id === template.parent
        ))
        if (parentMilestone) {
          const parentTemplate = parentMilestone.template as MilestoneTemplate
          let parentOrder = parentTemplate.order
          order = (parentOrder - 1) * 100 + order + 1
        } else {
          throw new Error('something went wrong')
        }
      } else {
        order = order * 100
      }
      return order
    })
    let firstIncompleteMilestone: Milestone | null = null
    for (let i = 0; i < sortedMilestones.length; i++) {
      if (sortedMilestones[i].status === 'TODO') {
        firstIncompleteMilestone = sortedMilestones[i]
        break
      }
    }
    if (firstIncompleteMilestone !== null) {
      const tasks = this.getTasksForMilestone(firstIncompleteMilestone)
      if (firstIncompleteMilestone.id === taskMilestone.id) {
        const currentMilestoneTasks = this.getTasksForMilestone(taskMilestone)
        return currentMilestoneTasks.length > 1
      }
      return tasks.length > 0
    } else {
      return true
    }
  }

  isTaskForNextMilestone () {
    let results = []
    if (this.$props.type === 'user') {
      results = [this.checkMilestones(this.trainingMilestones)]
    } else {
      results = this.onboardingData.map((onboardingData: { milestones: IOnboardingMilestone[], onboarding: IOnboarding }) => {
        const milestones = onboardingData.milestones
        return this.checkMilestones(milestones)
      })
    }
    return results.filter((result: boolean) => !result).length === 0
  }

  handleCompleteTask () {
    this.isWantCompleteTask = false
    if (this.taskIndex !== 0) {
      this.taskIndex--
    }
    this.$emit('update')
  }

  openCompleteTaskModal () {
    this.isWantCompleteTask = true
  }

  closeTaskModal () {
    this.isWantEditTask = false
    this.isWantAddTask = false
  }

  getActionIcon (action: EAdminTaskAction) {
    switch (action) {
      case EAdminTaskAction.CREATED: {
        return 'task'
      }
      case EAdminTaskAction.COMMENT: {
        return 'comment'
      }
      case EAdminTaskAction.RESCHEDULED: {
        return 'reschedule'
      }
      case EAdminTaskAction.EDITED: {
        return 'edit'
      }
      case EAdminTaskAction.COMPLETED: {
        return 'check'
      }
      default:
        return 'task'
    }
  }

  getHistoryActionLabel (action: EAdminTaskAction) {
    switch (action) {
      case EAdminTaskAction.CREATED: {
        return 'Task was created'
      }
      case EAdminTaskAction.COMPLETED: {
        return 'Task was completed'
      }
      case EAdminTaskAction.COMMENT: {
        return 'Task was commented'
      }
      case EAdminTaskAction.RESCHEDULED: {
        return 'Task was rescheduled'
      }
      case EAdminTaskAction.EDITED: {
        return 'Task was Edited'
      }
      default:
        return 'Unknwon action'
    }
  }

  scrollDown () {
    const area: any = document.querySelector('#comment-scroll-wrapper')
    if (!area) return
    area.scrollTo({
      top: area.scrollHeight
    })
  }

  goComments () {
    this.activeTab = 'responses'
    this.$nextTick(() => {
      const addComment = document.querySelector('#add-coment')
      if (addComment) {
        // @ts-ignore
        addComment.focus()
      }
    })
  }

  isPrevAvailable () {
    return this.taskIndex > 0
  }

  isNextAvailable () {
    return this.taskIndex < this.tasks.length - 1
  }

  dueDateMonth () {
    return moment(this.currentTask.dueDate).format('MMM DD')
  }

  isOverdue () {
    if (!this.currentTask.dueDate) {
      return false
    }
    return new Date(this.currentTask.dueDate).getTime() < Date.now()
  }

  dueDateTime () {
    return moment(this.currentTask.dueDate).format('hh a')
  }

  milestoneTemplateDetails (option: 'name' | 'hasParent' | 'childName'): string | boolean {
    const findParent = (templateId: number): MilestoneTemplate => this.milestoneTemplates.find((template: MilestoneTemplate) => template.id === templateId)
    const taskTemplate: MilestoneTemplate = this.taskTemplate
    const currentTask: MilestoneTemplate = this.milestoneTemplates.find((template: MilestoneTemplate) => template.id === Number(this.currentTask.category))
    const task = currentTask || taskTemplate
    if (!task) return 'No Milestone'
    switch (option) {
      case 'name':
          return task.parent ? findParent(task.parent as number).milestone : task.milestone
      case 'hasParent':
        return !!task.parent
      case 'childName':
        return task.milestone
    }
  }

  async fetchHistory () {
    if (this.currentTask) {
      await this.chainModuleInstance.fetchAdminTaskHistories(this.currentTask.id)
    }
  }

  goNextTask () {
    if (this.isNextAvailable()) {
      this.taskIndex++
      if (this.activeTask) {
        this.$router.replace({ query: { ...this.$route.query, activeTask: '' } })
      }
      this.$nextTick(async () => {
        await this.fetchHistory()
        if (this.activeTab === 'responses') {
          this.$nextTick(() => {
            this.scrollDown()
          })
        }
      })
    }
  }

  goPrevTask () {
    if (this.isPrevAvailable()) {
      this.taskIndex--
      if (this.activeTask) {
        this.$router.replace({ query: { ...this.$route.query, activeTask: '' } })
      }
      this.$nextTick(async () => {
        await this.fetchHistory()
        if (this.activeTab === 'responses') {
          this.$nextTick(() => {
            this.scrollDown()
          })
        }
      })
    }
  }

  formatText (text: string) {
    return text.replace(/[\n]/g, '<br/>')
  }

  async submitMessage (message: string) {
    if (message) {
      await this.chainModuleInstance.addAdminTaskHistoryComment({
        taskId: this.currentTask.id,
        data: {
          text: message,
          relatedId: this.$props.type === 'user' ? this.user.id : this.chain.id,
          page: this.$props.type,
          chainUserId: this.$props.type === 'user' ? this.user.id : null,
          chainId: this.$props.type === 'user' ? null : this.chain.id
        }
      })
      this.textMessage = ''
      // @ts-ignore
      this.$refs.textMessageBox.innerHTML = ''
      this.scrollDown()
      this.$emit('update')
    }
  }
}
